import React, { useState, useEffect } from "react";
import { TailwindWrapper } from "@utils/TailwindWrapper";
import { Button, Text, Icon, Accordion,Tooltip, Dialog } from "@ui-component-library";
import ReviewSlider from "../ReviewSlider";

  {/* Hero section */}
const HeroSection =({title,paragraph,heroButtonOne,heroButtonTwo, image})=>{
    return(
          <div className="bg-cloud-50">
            <div className="container">
                <TailwindWrapper>     
                    <div className="grid grid-cols-1 lg:grid-cols-2 px-6 gap-16 py-24">
                        <div className="grid grid-row content-center order-2 lg:order-1">
                            <div className="grid grid-row gap-6">
                                <Text variant="text-4xl/leading-none/medium">{title}</Text>
                                <Text variant="text-lg/leading-normal/normal" className="text-[#737373]">{paragraph}</Text>
                            </div>
                            <div className="pt-8 flex justify-start gap-3">
                                <Button
                                    tw
                                    onClick={heroButtonOne.onClick}
                                    variant="outline"
                                >
                                    {heroButtonOne.text}
                                </Button>
                                <Button
                                    tw
                                    onClick={heroButtonTwo.onClick}
                                    variant="primary"
                                > <React.Fragment key=".0">
                                        {heroButtonTwo.text}
                                        <Icon
                                            color="white-50"
                                            name="ArrowRightSimple"
                                        />
                                    </React.Fragment>

                                </Button>
                            </div>
                        </div>
                        <div className='order-1 lg:order-2 flex justify-center'>
                            {image}
                        </div>
                    </div>                 
                </TailwindWrapper>
            </div>
        </div>
    )

}

{/* Bento section */}
const BentoCard = ({ img, title, paragraph}) => {
        return (
            <div className="flex flex-col h-full rounded-xl overflow-hidden">
                <div className="h-[336px] w-full overflow-hidden">
                    {img}
                </div>
                <div className="p-6 flex flex-col gap-2 bg-cloud-200 sm:h-[150px] md:h-[300px] lg:h-[150px]">
                    <Text variant="text-lg/leading-normal/medium">{title}</Text>
                    {paragraph}
                </div>
            </div>
        )
    }

const BentoSection =({title,paragraph,children})=>{
   return( <div className="bg-cloud-50">
            <div className="container ">
                <TailwindWrapper>
                    <div className="py-24 px-6">
                        <div className="flex justify-center">
                            <div className="w-[576px] flex flex-col gap-5 ">
                                <Text variant="text-3xl/leading-normal/medium" className="text-center">{title}</Text>
                                {paragraph}
                            </div>
                        </div>                
                        {children}
                      
                    </div>
                </TailwindWrapper>
            </div>
        </div>)
}

{/* Customer testimonials section */}
const CustomerTestimonialSection = () => {
   return( <div style={{ backgroundColor: '#E5E1DC' }}>
        <div className="container">
            <TailwindWrapper>
                <div className="py-24 px-20">
                    <ReviewSlider />
                </div>
            </TailwindWrapper>
        </div>
    </div>)
}

{/*CTA section*/}
const CTASection = ({title, paragraph, ctaButton, secondaryCtaButton}) =>{
    return(
        <div style={{ backgroundColor: '#0F0F0F' }}>
            <div className="container ">
                <TailwindWrapper>
                    <div className="py-24 px-6 flex justify-center">
                        <div className="flex flex-col text-white text-center gap-5 max-w-[576px]">
                            <Text variant="text-3xl/leading-normal/medium">{title}</Text>
                            {paragraph}
                            <div className="flex justify-center mt-5 gap-4">
                                {secondaryCtaButton && <Button tw variant="outline" className="text-white-50" onClick={secondaryCtaButton?.onClick}><React.Fragment key=".0">
                                    {secondaryCtaButton?.text}
                                </React.Fragment></Button>}

                                <Button tw variant="outline" className="bg-white hover:text-white" onClick={ctaButton.onClick}><React.Fragment key=".0">
                                    {ctaButton?.text}
                                    <Icon
                                        name="ArrowRightSimple"
                                    />

                                </React.Fragment></Button>
                            </div>
                        </div>
                    </div>
                </TailwindWrapper>
            </div>

        </div>)
}

{/*Pricing section*/}
const PricingCard = ({ title, priceCardButton, features, backgroundColor = "white"}) => {
    const [openDialog, setOpenDialog] = useState({state:false,text:"",details:""})
    const [isTablet, setIsTablet] = useState(window.innerWidth < 1024);

     useEffect(() => {
            const handleResize = () => setIsTablet(window.innerWidth < 1024);
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);
    

    return (<><div className={`p-8 rounded-xl border-1 border-solid shadow-xl w-[325.33px] ${backgroundColor === "black" ? "bg-black border-white" : "bg-white border-[#E6E6E6]"}`}>
        <Text variant="text-lg/leading-normal/semibold" className={`${backgroundColor === "black" ? "text-white" : ""} text-start mb-4`}>{title}</Text>
        {priceCardButton?.state && <Button tw variant={`${backgroundColor == "black" ? "outline" : "primary"}`} className={`${backgroundColor == "black" ? "bg-white hover:text-white" : ""} mb-8 w-full`}
            onClick={priceCardButton?.onClick}>{priceCardButton?.text}</Button>}
        <Text variant="text-sm/leading-normal/medium" className={`${backgroundColor === "black" ? "text-white" : ""} text-start`}>{features.subtitle}</Text>
        {features.info.map((feature, index) => {
            return (
                !isTablet ?
                    <Tooltip
                        key={index}
                        content={<><Text variant="text-sm/leading-normal/normal">{feature.text}</Text><Text variant="text-sm/leading-normal/normal">{feature.details}</Text></>}>
                        <div className="flex justify-between items-center mt-4">
                            <div className="flex justify-start">
                                <Icon tw name="CheckSimple" className={`${backgroundColor == "black" ? "fill-white" : ""} me-3`} />
                                <Text variant="text-sm/leading-normal/normal" className={`${backgroundColor === "black" ? "text-white" : ""} text-start `}>{feature.text}</Text>
                            </div>
                            <Icon tw name="InfoOutlined" className={`${backgroundColor == "black" ? "fill-white" : ""}`} />
                        </div> </Tooltip> :
                    <div key={index} className="flex justify-between items-center mt-4" onClick={() => { setOpenDialog({state:true, text:feature.text,details:feature.details}) }}>
                        <div className="flex justify-start">
                            <Icon tw name="CheckSimple" className={`${backgroundColor == "black" ? "fill-white" : ""} me-3`} />
                            <Text variant="text-sm/leading-normal/normal" className={`${backgroundColor === "black" ? "text-white" : ""} text-start `}>{feature.text}</Text>
                        </div>
                        <Icon tw name="InfoOutlined" className={`${backgroundColor == "black" ? "fill-white" : ""}`} />
                    </div>)
        })}
    </div>
        <Dialog isOpen={openDialog.state} size='small'>
            <Dialog.Header className="justify-between items-center">
                <Text variant="text-sm/leading-normal/normal">{openDialog?.text}</Text>
                <Button tw variant="outline" size="icon" onClick={() => setOpenDialog({ state: false })}>
                    <Icon name="CrossSimple" className="color-charcoal-500" size="medium" />
                </Button></Dialog.Header>
            <Dialog.Content><Text variant="text-sm/leading-normal/normal">{openDialog?.details}</Text></Dialog.Content>
        </Dialog></>)

    }

const PricingSection =({title,paragraph, children})=>{
    return (<div className="bg-cloud-50">
            <div className="container ">
                    <TailwindWrapper>
                    <div className="py-24 md:px-6">
                        <div className="flex justify-center">
                            <div className="w-[576px] flex flex-col gap-5 mb-8">
                                <Text variant="text-3xl/leading-normal/medium" className="text-center">{title}</Text>
                                {paragraph}
                            </div>
                        </div>
                       {children}
                    </div>
                </TailwindWrapper>
            </div>

        </div>)
}

 {/* FAQ section */}
const FAQComponent = ({ question, answer }) => {
        return (
            <Accordion className="border-b border-solid border-[#E6E6E6] py-4">
                <Accordion.Header>
                    <Text variant="text-sm/leading-normal/medium">{question}</Text>
                </Accordion.Header>
                <Accordion.Content>{answer}</Accordion.Content>
            </Accordion>
        )
    }
   
const FAQSection = ({title,paragraph,children})=>{
    return(       
        <div className="bg-cloud-50">
            <div className="container ">
                <TailwindWrapper>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-16 py-24 px-6">
                        <div className="flex flex-col justify-start gap-lg">
                            {/* <Text variant="text-sm/leading-normal/medium" className="text-[#737373]">FAQ section</Text> */}
                            <Text variant="text-3xl/leading-normal/medium">{title}</Text>
                            <Text variant="text-base/leading-normal/normal" className="text-[#737373]">{paragraph}</Text>
                        </div>
                        <div>
                            {children}
                        </div>

                    </div>
                </TailwindWrapper>
            </div>
        </div>
    )
}

export {HeroSection, BentoCard, BentoSection,CustomerTestimonialSection,CTASection,PricingCard,PricingSection,FAQComponent,FAQSection}
